import React from 'react';

export function SectionHeading({ overline, title, subtitle, light = false, align = 'left' }) {
  const alignCls = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {overline && <p className="brp-overline">{overline}</p>}
      <h2
        className={`mt-4 font-display uppercase tracking-tight font-bold text-4xl md:text-5xl lg:text-6xl leading-[0.95] ${
          light ? 'text-white' : 'text-[#0A0A0A]'
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-6 text-base md:text-lg leading-relaxed ${
            light ? 'text-gray-300' : 'text-[#555]'
          }`}
        >
          {subtitle}
        </p>
      )}
      <span className="brp-divider-gold mt-8" />
    </div>
  );
}

export function FeatureCard({ icon: Icon, title, desc, dark = false, accent = false, testId }) {
  return (
    <div
      className={`${dark ? 'brp-card-dark' : 'brp-card'} p-8 md:p-10 h-full`}
      data-testid={testId}
    >
      {accent && (
        <div className="absolute top-0 left-0 h-1 w-16 bg-[#D4AF37]" />
      )}
      {Icon && (
        <div className="w-12 h-12 flex items-center justify-center border border-[#D4AF37] mb-6">
          <Icon size={22} strokeWidth={1.75} className="text-[#D4AF37]" />
        </div>
      )}
      <h3
        className={`font-display uppercase tracking-wide text-xl md:text-2xl font-bold ${
          dark ? 'text-white' : 'text-[#0A0A0A]'
        }`}
      >
        {title}
      </h3>
      <p className={`mt-4 leading-relaxed ${dark ? 'text-gray-400' : 'text-[#555]'}`}>
        {desc}
      </p>
    </div>
  );
}

export function KpiTile({ value, label, suffix, testId }) {
  return (
    <div
      className="bg-[#0A0A0A] text-white p-6 md:p-8 border-l-4 border-[#D4AF37] relative overflow-hidden"
      data-testid={testId}
    >
      <div className="font-display text-5xl md:text-6xl font-bold text-[#D4AF37] leading-none tracking-tight">
        {value}
        {suffix && <span className="text-2xl ml-1 text-white/70">{suffix}</span>}
      </div>
      <div className="mt-4 text-xs uppercase tracking-[0.2em] text-gray-400 font-bold">
        {label}
      </div>
    </div>
  );
}

export function BulletList({ items, dark = false }) {
  return (
    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-6">
      {items.map((it) => (
        <li
          key={it}
          className={`flex items-start gap-3 text-sm ${dark ? 'text-gray-300' : 'text-[#333]'}`}
        >
          <span className="mt-1 w-2 h-2 bg-[#D4AF37] inline-block flex-shrink-0" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
}

export function ImageBlock({ src, alt, caption, ratio = 'aspect-[4/3]' }) {
  return (
    <div className={`relative overflow-hidden ${ratio} group`}>
      <img
        src={src}
        alt={alt}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
      {caption && (
        <div className="absolute bottom-4 left-4 right-4">
          <span className="bg-[#D4AF37] text-[#0A0A0A] px-3 py-1 font-display uppercase text-[10px] tracking-[0.2em]">
            {caption}
          </span>
        </div>
      )}
    </div>
  );
}
